<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        class="mb-5"
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf" class="flex flex-col gap-y-10">
          <a-table 
            v-for="(item, i) in result"
            :key="i"
            :dataSource="[...item.matters, item.client].reverse()"
            :columns="columns"
            :pagination="false"
            class="tbl-receivable"
          >
              <template slot="client" slot-scope="text,record">
                <template>{{ item.client.name }}</template>
              </template>
              <template slot="matter" slot-scope="text,record">
                <template v-if="record.matter_name !== undefined">{{ record.matter_name }}</template>
                <template v-else>Client funds(Not linked to a matter)</template>
              </template>
              <template slot="below_minimum" slot-scope="text,record">
                <template v-if="record.matter_name !== undefined">{{ record.below_minimum }}</template>
                <template v-else>-</template>
              </template>
              <template slot="minimum_threshold" slot-scope="text,record">
                <template v-if="record.matter_name !== undefined">{{ record.minimum_threshold }}</template>
                <template v-else>-</template>
              </template>
              <template slot="unbill" slot-scope="text,record">
                <template v-if="record.matter_name !== undefined">{{ record.unbill }}</template>
                <template v-else>-</template>
              </template>
              <template slot="footer">
                <template v-if="item.matters.length">
                    <div class="grid grid-cols-6">
                      <div class="col-span-1 place-self-center">{{ currencySymbol + sumCol(item.matters,'balance') }}</div>
                      <div class="col-span-2 ml-16">{{ currencySymbol + sumCol(item.matters,'below_minimum') }}</div>
                      <div class="col-span-3 place-self-end">{{ currencySymbol + sumCol(item.matters,'unbill') }}</div>
                    </div>
                  </template>
              </template>
            </a-table>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Responsible Lawyer">
              <a-radio-group v-decorator="['which_responsible',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleChangeUser">
                <a-radio :style="radioStyle" :value="1">
                  All Lawyers
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Responsible Lawyer
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <SelectOption
              v-show="responsible_value === 2"
              url="/account/list/"
              label="Responsible"
              field="responsible"
              :required="false"
              method="get"
              placeholder="Find A User"
              mode="multiple"
              class="w-full xl:w-1/2 self-end"
            />
          </div>
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Originating Lawyer">
              <a-radio-group v-decorator="['which_originating',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleChangeOriginating">
                <a-radio :style="radioStyle" :value="1">
                  All Originating Lawyers
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Originating Lawyer
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <SelectOption
              v-show="originating_value === 2"
              url="/account/list/"
              label="Originating"
              field="origination"
              :required="false"
              method="get"
              placeholder="Find A User"
              mode="multiple"
              class="w-full xl:w-1/2 self-end"
            />
          </div>
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Trust accounts">
              <a-radio-group v-decorator="['which_account',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleChangeAccount">
                <a-radio :style="radioStyle" :value="1">
                  All accounts
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Specific Account
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <selectSearch
              v-show="account_value === 2"
              :required="false"
              url="/bank-account/query/"
              :options="{placeholder: 'Search accounts',label: 'accounts',field: 'account',width: '100%',allow_clear: true}"
              class="self-end mt-8 md:mt-0 w-full xl:w-1/2"
              :is_include_bank_account="true"
            />
          </div>
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Client/Matter">
              <a-radio-group v-decorator="['which_client_matter',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleMatterClient">
                <a-radio :style="radioStyle" :value="1">
                  All Clients
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Specific Client
                </a-radio>
                <a-radio :style="radioStyle" :value="3">
                  Specific Matter
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <selectSearch
              v-show="checked_matter_client === 3"
              :required="false"
              url="/matter/query/"
              :options="optionSearchMatter"
              class="self-end mt-8 md:mt-0 w-full xl:w-1/2"
              :is_include_matter="true"
              @selectSearch="() => handleSearchField('contact')"
            />
            <selectSearch
              v-show="checked_matter_client === 2"
              :required="false"
              url="/contact/query/"
              :options="optionSearchContact"
              class="w-full xl:w-1/2 self-center mt-8 md:mt-0 w-full"
              :is_include_matter="false"
              @selectSearch="() => handleSearchField('matter')"
            />
          </div>
          <a-form-item label="Matter Status" has-feedback>
            <a-select v-decorator="['status',{ rules: [{ required: false, message: 'this field is required.' }] }]" allowClear>
              <a-select-option :value="1">
                 Open
              </a-select-option>
              <a-select-option :value="2">
                 Closed
              </a-select-option>
              <a-select-option :value="3">
                Pending
              </a-select-option>
            </a-select>
          </a-form-item>
          <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area" field="practice_area" method="get"/>
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit('changeTab','ClientReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from "@/components/pdf/ExportPdf";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const columns = [
  {
    title: 'Client',
    dataIndex: 'client',
    key: '1',
    scopedSlots: { customRender: 'client' },
  },
  {
    title: 'Matter',
    dataIndex: 'matter_name',
    key: '2',
    scopedSlots: { customRender: 'matter' },
  },
  {
    title: 'Balance',
    dataIndex: 'balance',
    key: '3',
  },
  {
    title: 'BelowMinimum',
    dataIndex: 'below_minimum',
    key: '4',
    scopedSlots: { customRender: 'below_minimum' },
  },
  {
    title: 'MinimumThreshold',
    dataIndex: 'minimum_threshold',
    key: '5',
    scopedSlots: { customRender: 'minimum_threshold' },
  },
  {
    title: 'Unbill',
    dataIndex: 'unbill',
    key: '6',
    scopedSlots: { customRender: 'unbill' },
  },
];

export default {
  name: "ComponentAccountManagement",
  mixins:[mixin],
  components:{
    BtnSubmitReport,
    Actions,
    ExportPdf,
    SelectOption,
    selectSearch
  },
  data(){
    return{
      responsible_value: null,
      account_value    : null,
      originating_value: null,
      checked_matter_client: null,
      title:'Client Account Management',
      columns,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },
  computed: {
    currencySymbol() {
      return localStorage.getItem('currency_symbol')
    },
  },
  methods:{
    handleChangeUser({target:{value}}){
      if (value === 1)
        this.form.setFieldsValue({ responsible: [] })
      this.responsible_value = value
    },
    handleChangeOriginating({target:{value}}){
      if (value === 1)
        this.form.setFieldsValue({ origination: [] })
      this.originating_value = value
    },
    handleChangeAccount({target:{value}}){
      this.account_value = value
    },
    handleReport(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try {
            this.$refs.reportSubmit.loading = true
            const query     = []
            if (values.contact)       query.push({ field:'id', condition: '=', value: values.contact, operation: 'and' })
            if (values.matter)        query.push({ field:'client_matters', condition: '=', value: values.matter, operation: 'and' })
            if (values.status)        query.push({ field:'client_matters__status', condition: '=', value: values.status, operation: 'and' })
            if (values.responsible && values.responsible.length) query.push({ field:'client_matters__responsible__id', condition: 'in', value: values.responsible, operation: 'and' })
            if (values.origination && values.origination.length) query.push({ field:'client_matters__origination__id', condition: 'in', value: values.origination, operation: 'and' })
            if (values.practice_area) query.push({ field:'client_matters__practice_area', condition: '=', value: values.practice_area, operation: 'and' })
            const {data}    = await axios.post('contact/report/account-management',{ query: query.length ? query : undefined, bank_account_id: values.account || undefined  })
            this.visibleRes = true
            this.result     = Object.values(data)
          }catch (e) {
            this.visibleRes = false
            this.$message.error('Error generating report')
            throw new Error(e)
          }finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    },
    handleSearchField(field){
      this.form.resetFields(field)
    },
  }
}
</script>

<style>
@import "../../style/style.css";
</style>
